/* eslint-disable no-unused-vars */
export enum KeyCode {
  Backspace = 8,
  Tab = 9,
  Enter = 13,
  Escape = 27,
  LeftArrow = 37,
  UpArrow = 38,
  RightArrow = 39,
  DownArrow = 40,
}

export enum ReservationType {
  CompanyOwned = 0,
  Referral = 1,
}

export enum InfoModalVariant {
  Simple = 'simple',
  Standard = 'standard',
  Itemized = 'itemized',
  Custom = 'custom',
  Payment = 'payment',
}

export enum OpportunityStatusType {
  Available = 1,
  Fulfilled = 2,
  Processing = 3,
}

export enum ReservationStatus {
  Upcoming = 'upcoming',
  Started = 'started',
  Finished = 'finished',
  Cancelled = 'cancelled',
  Hold = 'hold',
}

export enum ReferralStatus {
  Offered = 'offered',
  Reoffered = 'reoffered',
  Accepted = 'accepted',
  Rejected = 'rejected',
}

export enum PaymentStatus {
  NotPaid = 'not_paid',
  PartiallyPaid = 'partially_paid',
  FullyPaid = 'fully_paid',
}

export enum PaymentTerms {
  Net3 = 'net_3',
  Net14 = 'net_14',
  Net30 = 'net_30',
  Pending = 'pending',
}

export enum BidStatus {
  Pending = 'pending',
  Accepted = 'accepted',
  Rejected = 'rejected',
}

export enum BidStatusId {
  Pending = 1,
  Accepted = 2,
  Rejected = 3,
}

export enum TripTypeKeys {
  OneWay = 'one_way',
  RoundTrip = 'round_trip',
  Hourly = 'hourly',
  Daily = 'daily',
  Shuttle = 'shuttle',
}

export enum TakeRate {
  Default = 10,
}

export enum EldTypeV2 {
  Samsara = 'SAMSARA',
  Motive = 'MOTIVE',
  Coachrail = 'COACHRAIL',
  Geotab = 'GEOTAB',
  Busify = 'BUSIFY',
  VerizonConnect = 'VERIZON',
  Saucon = 'SAUCON',
}

export enum CredentialsStatus {
  AccessFailure = 'ACCESS_FAILURE',
}

export enum EldType {
  Trak4 = 1,
  Samsara = 2,
  Motive = 3,
  Coachrail = 4,
  Geotab = 5,
  Busify = 6,
  VerizonConnect = 7,
  Saucon = 8,
}

export enum EldTypeKey {
  Trak4 = 'trak4',
  Samsara = 'samsara',
  Motive = 'motive',
  Geotab = 'geotab',
  VerizonConnect = 'verizonConnect',
  Saucon = 'saucon',
  Geotb = 'geotab',
}

export enum EldTypeLabel {
  Trak4 = 'Trak4',
  Samsara = 'Samsara',
  Motive = 'Motive',
  Geotab = 'Geotab',
  VerizonConnect = 'VerizonConnect',
  Saucon = 'Saucon',
  GeoTab = 'Geotab',
}

export enum MobileDeviceType {
  Busify = 'BUSIFY',
  Coachrail = 'COACHRAIL',
}

export enum MotiveClient {
  Id = '2ea8e268775927efc960a0184630a4c383c70b06dacfea39a7f7a01abc0fb157',
  Scope = 'eld_devices.read locations.vehicle_locations_list locations.vehicle_locations_single locations.driver_locations vehicles.read users.read',
}

export enum TrackingReservationStatus {
  Upcoming = 'UPCOMING',
  Started = 'STARTED',
  Finished = 'FINISHED',
}

export enum ReservationTrackingAllocation {
  All = 'ALL',
  Partial = 'PARTIAL',
  None = 'NONE',
}

export enum NoteTypeId {
  Internal = 1,
  Customer = 2,
  Driver = 3,
}

export enum ReferralRejectionReasonKey {
  NoAvailability = 'no_availability',
  IncorrectPricing = 'incorrect_pricing',
  IncorrectVehicle = 'incorrect_vehicle',
  DriverShortage = 'driver_shortage',
  DangerousRoute = 'dangerous_route',
}

export enum BookingAction {
  Accept = 'accept',
  Reject = 'reject',
}

export enum MarkupTypeId {
  VehicleType = 7,
  SPAB = 9,
  MountainTrip = 10,
  AreaOfInterest = 13,
}

export enum AreaOfInterest {
  Mountain = 1,
  Border = 2,
}

export enum PartnerTypeId {
  GoldReseller = 1,
  SilverReseller = 2,
  Platinum = 3,
  Gold = 4,
  Silver = 5,
  Bronze = 6,
  NonPartner = 7,
  CoachRailOnly = 8,
  Onboarding = 9,
  Suspended = 10,
}

export enum OnboardingStatusTypeIdTypeId {
  NotOnboarded = 1,
  CurrentlyOnboarding = 2,
  Onboarded = 5,
}

export enum AmenityTypeId {
  Wifi = 1,
  Luggage = 2,
  Bathroom = 3,
  SeatBelts = 4,
  ADACompliant = 5,
  TVScreens = 6,
  Outlets = 7,
  LeatherSeats = 8,
  CDCCompliant = 9,
  DODCompliant = 10,
  SPABCompliant = 11,
  AlcoholConsumption = 12,
  MountainDriver = 13,
  NineteenACertification = 14,
  AuxBluetooth = 15,
  PASystem = 16,
  BottledWater = 17,
  MakeModelYear = 18,
  BusColor = 19,
  BusLogos = 20,
  NonStandard = 21,
  TripCoordinators = 22,
  BusWraps = 23,
  VehicleStaysOnSite = 24,
  ACHeat = 25,
}

export enum AmenityTypeKey {
  Wifi = 'wifi',
  Luggage = 'luggage',
  Bathroom = 'lavatory',
  SeatBelts = 'seatbelts',
  ADACompliant = 'ada',
  TVScreens = 'tv_screens',
  Outlets = 'outlets',
  LeatherSeats = 'leather_seats',
  CDCCompliant = 'cdc',
  DODCompliant = 'dod',
  SPABCompliant = 'spab',
  AlcoholConsumption = 'alcohol_allowed',
  MountainTrip = 'mountain_trip',
  NineteenACertification = '19a_certification',
  AuxBluetooth = 'aux_bluetooth',
  PASystem = 'pa_system',
  BottledWater = 'bottled_water',
  MakeModelYear = 'make_model_year',
  VehicleColor = 'vehicle_color',
  VehicleLogos = 'vehicle_logos',
  NonStandard = 'non_standard_vehicle_size',
  TripCoordinators = 'trip_coordinators',
  BusWraps = 'wraps',
  VehicleStaysOnSite = 'vehicle_stays_on_site',
  ACHeat = 'ac_heat',
}

export enum BestEffortAmenityTypeIds {
  MakeModelYear = 18,
  BusColor = 19,
  BusLogos = 20,
  NonStandard = 21,
  TripCoordinators = 22,
  BusWraps = 23,
}

export enum AmenityClassificationTypeId {
  Trip = 1,
  Vehicle = 2,
  Driver = 3,
}

export enum CancellationReminderDayRange {
  RequireReminder = 30,
  RequireAssignment = 2,
}

export enum CancellationTicketStatus {
  Requested = 'Requested',
  Cancelled = 'Cancelled',
  Denied = 'Denied',
}

export enum CancellationStatusKey {
  Requested = 'requested',
  Cancelled = 'cancelled',
  Denied = 'denied',
}

export enum CompanyId {
  CharterUP = 2,
}

export enum VehicleAvailabilityCreationSource {
  DateRange = 'dateRange',
  Rejection = 'rejection',
  MarkedSoldOut = 'markedSoldOut',
}

export enum ApplicationId {
  Busify = 4,
}

export enum RiskTypeLabel {
  IncompleteAddress = 1,
  PickupTimeMissing = 2,
  DriverHotelMissing = 3,
  FlightInfoMissing = 4,
  NonDOTCompliant = 5,
  IncompleteStop = 6,
  MissingStop = 7,
}

export enum SplitTrafficType {
  Anonymous = 'anonymous',
  Company = 'company',
  User = 'user',
}

export enum SplitKeyType {
  AnonymousCompany = 'anonymous',
}

export enum SplitFeatureFlag {
  // Placeholder for future use
  SampleFlag = 'sample-flag',
  VehicleAmenityUpdates = 'c4o-vehicle-amenity-updates',
  DriverAppPromo = 'driver-app-promo',
  DisableOperatorMinimumRates = 'disable-operator-minimum-rates',
}

export enum SplitAttribute {
  OperatorMarket = 'operator-market',
}

export enum PerformanceWidgetLabel {
  AboveTarget = 'On Target',
  Standard = 'Needs Attention',
  ActionRequired = 'Action Required',
  Calculating = 'Not Calculated',
}

export enum MetricsChipLabel {
  AboveTarget = 'On Target',
  Standard = 'Needs Attention',
  ActionRequired = 'Action Required',
}

export enum AcceptanceThreshold {
  SignificantDeltaPercentage = 0.05,
  DaysToUpdateAvailability = 6,
}

export enum FulfillmentThreshold {
  SignificantDeltaPercentage = 0.05,
  DaysToUpdateAvailability = 6,
}

export enum OnTimeThreshold {
  SignificantDeltaPercentage = 0.05,
  DaysToUpdateAvailability = 6,
}

export enum TrackingThreshold {
  SignificantDeltaPercentage = 0.05,
}

export enum EndpointValidationStatus {
  Inactive = 'INACTIVE',
  Waiting = 'WAITING',
  Success = 'SUCCESS',
  Failure = 'FAILURE',
}

export enum VINVerificationTypeKey {
  PendingValidation = 'pending_validation',
  Invalid = 'invalid',
  Valid = 'valid',
  PendingVerification = 'pending_verification',
  Verified = 'verified',
  VerificationFailure = 'verification_failure',
}

export enum VINReviewStatusKey {
  Pending = 'pending',
  Rejected = 'rejected',
  Accepted = 'accepted',
  Cancelled = 'cancelled',
}

export enum VINReviewTypeKey {
  Update = 'update',
  Create = 'create',
}

export enum TierKey {
  VIP = 'vip',
  PLUS = 'plus',
  STANDARD = 'standard',
}

export enum VehicleTypeId {
  CharterBus = 1,
  MiniBus = 2,
  Sprinter = 3,
  PartyBus = 4,
  Sedan = 5,
  SUV = 6,
  Limousine = 7,
  Trolley = 8,
  SchoolBus = 9,
  Van = 10,
}

export enum VehicleTypeKey {
  CharterBus = 'charter_bus',
  MiniBus = 'mini_bus',
  Sprinter = 'sprinter',
  PartyBus = 'party_bus',
  Sedan = 'sedan',
  SUV = 'suv',
  Limousine = 'limousine',
  Trolley = 'trolley',
  SchoolBus = 'school_bus',
  Van = 'van',
}

export enum RateTypeKey {
  DailyRate = 'daily_rate',
  HourlyRate = 'hourly_rate',
  Mileage = 'mileage',
}

export enum SpecialRequirementsTypeLabel {
  ADA = 'ADA',
  SPAB = 'SPAB',
  VehicleNeededEntireTrip = 'Vehicle stays on-site',
}

export enum SpecialRequirementsTypeKey {
  ADA = 'ada',
  SPAB = 'spab',
  VehicleNeededEntireTrip = 'vehicle_needed_entire_trip',
}

export enum TripTypeId {
  OneWay = 1,
  RoundTrip = 2,
  Hourly = 3,
  Daily = 4,
  Shuttle = 5,
  LargeEvent = 6,
  LongTermShuttle = 7,
}

export enum TripTypeKey {
  OneWay = 'one_way',
  RoundTrip = 'round_trip',
  Hourly = 'hourly',
  Daily = 'daily',
  Shuttle = 'shuttle',
  LargeEvent = 'large_event',
  LongTermShuttle = 'long_term_shuttle',
}

export enum TripTypeLabel {
  OneWay = 'One Way',
  RoundTrip = 'Round Trip',
  Hourly = 'Hourly',
  Daily = 'Daily',
  Shuttle = 'Shuttle',
  LargeEvent = 'Large Event',
  LongTermShuttle = 'Long Term Shuttle',
}

export enum VehicleTypeLabel {
  CharterBus = 'Charter Bus',
  MiniBus = 'Mini Bus',
  Sprinter = 'Sprinter',
  PartyBus = 'Party Bus',
  Sedan = 'Sedan',
  SUV = 'SUV',
  Limousine = 'Limousine',
  Trolley = 'Trolley',
  SchoolBus = 'School Bus',
  Van = 'Van',
}

export enum TrackingIndicator {
  GREEN = 'GREEN',
  YELLOW = 'YELLOW',
  RED = 'RED',
  GRAY = 'GRAY',
}

export enum VehicleAmenityAttestedStatus {
  Unverified = 'UNVERIFIED',
  DoesNotMeetExpectation = 'DOES_NOT_MEET_EXPECTATION',
  MeetsExpectation = 'MEETS_EXPECTATION',
  UnderReview = 'UNDER_REVIEW',
}

export enum VehicleProfileStatus {
  Incomplete = 'INCOMPLETE',
  NeedsAttention = 'NEEDS_ATTENTION',
  PendingApproval = 'PENDING_APPROVAL',
  Complete = 'COMPLETE'
}

export const VehicleProfileStatusLabels: Record<VehicleProfileStatus, string> = {
  [VehicleProfileStatus.Incomplete]: 'Incomplete',
  [VehicleProfileStatus.NeedsAttention]: 'Needs Attention',
  [VehicleProfileStatus.PendingApproval]: 'Pending Approval',
  [VehicleProfileStatus.Complete]: 'Complete',
}

export enum VehicleAmenityReviewStatus {
  AwaitingEvidence = 'AWAITING_EVIDENCE',
  AwaitingDecision = 'AWAITING_DECISION',
  Approved = 'APPROVED',
  Rejected = 'REJECTED',
  Cancelled = 'CANCELLED'
}